import { defineStore } from 'pinia';

export const useToastStore = defineStore('toast', {
  state: () => ({
    toastRef: null,
  }),
  actions: {
    add(slice) {
      if (this.toastRef) {
        this.toastRef.add(slice);
      }
    },
  },
});
